import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { GlobalOutlined } from "@ant-design/icons";
import { LanguageSwitcherContainer } from "./LanguageSwitcher.styled";

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
  };

  return (
    <LanguageSwitcherContainer>
      <Select
        value={i18n.language}
        onChange={handleLanguageChange}
        style={{ width: 120 }}
        suffixIcon={<GlobalOutlined />}
        options={[
          {
            value: "am",
            label: t("language.am"),
          },
          {
            value: "en",
            label: t("language.en"),
          },
          {
            value: "ru",
            label: t("language.ru"),
          },
        ]}
      />
    </LanguageSwitcherContainer>
  );
};

export default LanguageSwitcher;
